<template>
    <div class="instrumentTime">
        <div class="layout-page-box">
            <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
                <el-form-item label="院区">
                    <el-select v-model.trim="filters.areaId" placeholder="请选择院区" clearable>
                        <el-option v-for="(item) in ranks" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="科室">
                    <el-select v-model.trim="filters.dsepartmentCode" placeholder="请选择科室" clearable>
                        <el-option v-for="(item) in departments" :key="item.id" :label="item.departmentName" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model.trim="filters.clientName" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="上传人">
                    <el-select @focus="focus" filterable remote clearable v-model="filters.createBy" placeholder="选择上传人" multiple>
                        <el-option v-for="(item) in manList" :key="item.id" :label="item.userName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model.trim="filters.clientMobile" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="时间">
                    <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search" size="small">查询</el-button>
                    <el-button type="primary" @click="add" size="small" icon="el-icon-upload">上传文件</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="layout-page-box">
            <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column sortable prop="clientName" label="姓名"></el-table-column>
                <el-table-column prop="clientMobile" label="手机号" width="150">
                    <template slot="header">
                        <span>手机号</span>
                        <el-button style="margin-left:10px;" v-permission="'90'" @click="show" class="filter-item" type="success" size="mini" icon="el-icon-view"></el-button>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="mobileHiding==true">{{scope.row.clientMobile}}</span>
                        <span v-if="mobileHiding==false">
                            <div v-for="(item,index) in scope.row.clientMobile.split('/')" :key='index'>{{item.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2")}}</div>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column sortable prop="areaName" label="院区"></el-table-column>
                <el-table-column sortable prop="dsepartmentName" label="科室"></el-table-column>
                <el-table-column sortable prop="createBy" label="上传人"></el-table-column>
                <el-table-column sortable prop="operationTime" label="手术时间"></el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
                        <!-- <el-button size="mini" type="danger" @click="del(scope.$index, scope.row)">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
            </el-pagination>
        </div>
        <!-- 新增编辑身份弹框 -->
        <el-dialog v-if="dialogFormVisible" :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false" title="上传文件">
            <add @close="close" :formData="formData" @add-comment="appendComment"></add>
        </el-dialog>
        <!-- 病历列表弹框 -->
        <el-dialog v-if="listVisible" :visible.sync="listVisible" center class="dialogItem" title="病历列表" :close-on-click-modal="false">
            <list @toparent="getson" @close1="close1" @add-comment="appendComment" :childData="childData"></list>
        </el-dialog>
        <!-- 病历列表详情 -->
        <div class="next">
            <el-dialog v-loading="loading" v-if="iframeVisible" :visible.sync="iframeVisible" center :close-on-click-modal="false">
                <iframe id="iframe" :src="this.url.replace(/%2B/g, '%2%42')" frameborder="0" width="100%" height="850px"></iframe>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import list from './list'
import add from './add'
import { mapState, mapGetters } from 'vuex'
import permission from '../../directives/permission/index'
export default {
    directives: {
        permission
    },
    components: {
        list, add
    },
    computed: {
        ...mapState(['departments']),
    },
    name: 'case',
    data() {
        return {
            filters: {
                types: '',
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
                startTime: '',
                endTime: '',
            },
            tableData: [],
            multipleSelection: [],
            dialogFormVisible: false,
            iframeVisible: false,
            formData: {},
            childData: {},
            tableHeight: '',
            ranks: this.$store.state.ranks,
            listVisible: false,
            url: '',
            loading: false,
            manList: [],
            mobileHiding: false,
        }
    },
    created() {
        this.tableHeight = document.documentElement.clientHeight - 380
    },
    mounted() {
        /*this.init();*/
        this.query(this.filters.pagination.page);
        this.$store.dispatch('getDepartment')
    },
    watch: {
        $route(to, from) {
            if (this.activatedFlag) {
                this.query(this.filters.pagination.page);
            }
        },
    },
    methods: {
        show() {
            this.mobileHiding = !this.mobileHiding
        },
        focus() {
            api.request("/employee/findEmployeeListAll", {}, (res) => {
                this.manList = res.data.createByList
            })
        },
        getson(data) {
            if (data.fileUrl) {
                this.loading = true
                this.iframeVisible = true
                var suffix = data.fileName.substring(data.fileName.lastIndexOf(".") + 1);
                console.log(suffix);
                if (suffix == 'pdf') {
                    this.url = data.fileUrl + "?time=" + new Date().getTime()
                } else {
                    this.url = 'https://view.officeapps.live.com/op/view.aspx?src=' + (data.fileUrl).replace('%2B', '%2%42') + "?time=" + new Date().getTime()
                }
                // http://view.xdocin.com/xdoc?_xdoc=
                // 判断ifram是否加载完毕
                const self = this
                this.$nextTick(() => {
                    const iframe = document.querySelector('#iframe')
                    if (iframe.attachEvent) {
                        iframe.attachEvent("onload", function () {
                            self.loading = false
                        });
                    } else {
                        iframe.onload = function () {
                            self.loading = false
                        };
                    }
                })

            } else if (!data.fileUrl) {
                _g.toast("warning", '请选择要查看的文件!!!');
                return;
            }
        },
        search() {
            this.filters.pagination.page = 1
            this.refresh()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pageChanged(page) {
            this.filters.pagination.page = page
            this.refresh()
        },
        handleSizeChange(sizes) {
            this.filters.pagination.limit = sizes
            this.refresh()
        },
        refresh() {
            router.push({
                path: this.$route.path,
                query: _.merge({}, this.$route.query, {
                    __query: JSON.stringify(this.pagination)
                }, {
                        random: Math.random()
                    })
            })
        },

        handleEdit(index, row) {
            this.listVisible = true
            let querys = {
                clientName: row.clientName,
                clientMobile: row.clientMobile
            }
            api.request('/register/findElectronicCaseList', querys, (res) => {
                this.childData = res.data
            })
        },

        // 新增项目
        add() {
            this.dialogFormVisible = true
            this.formData = {}
        },
        close() {
            this.dialogFormVisible = false
        },
        close1() {
            this.listVisible = false
        },
        appendComment(item) {
            this.query(this.filters.pagination.page);
        },
        // 查询数据列表
        query(page) {
            // console.log(this.filters.startTime)
            var querys = {
                startTime: '',
                endTime: '',
                page: page,
                size: this.filters.pagination.limit,
                clientName: this.filters.clientName,
                clientMobile: this.filters.clientMobile,
                areaId: this.filters.areaId,
                dsepartmentCode: this.filters.dsepartmentCode,
                createBy: this.filters.createBy.toString(),
            }
            if (this.filters.startTime) {
                querys.startTime = this.filters.startTime[0]
                querys.endTime = this.filters.startTime[1]
            }
            // console.log(querys)
            api.request('/register/findElectronicCasePage', querys, (res) => {
                // console.log(res)
                var data = res.data.list
                this.tableData = data
                this.filters.pagination.total = parseInt(res.data.count)
                this.tableData.forEach(ele => {
                    let reg = new RegExp('，', 'g')//g代表全部
                    ele.mobile = (ele.mobile).replace(reg, '/');
                });
            })
        },
    },


}
</script>
<style scoped>
@import "../../assets/css/main.css";
.next >>> .el-dialog {
  width: 90% !important;
}
.next >>> .el-dialog__header {
  padding: 0 !important;
  box-sizing: border-box;
}
.next >>> .el-dialog__body {
  padding: 30px 4px 0 !important;
  box-sizing: border-box;
}
.next >>> .el-icon-close:before {
  font-size: 22px !important;
  font-weight: bold;
}
.next >>> .el-dialog__headerbtn {
  top: 10px !important;
  right: 4px;
}
.instrumentTime >>> .el-button i {
  margin-right: 0px !important;
}
</style>